import React from 'react';
import ListBike from '../../../common/listBike/ListBike';
import Loader from '../../../common/loader/Loader';
import './BikesPage.scss';

class BikesPage extends React.Component<any, any> {
    
    displayBikePage = () => {
        if(this.props.isLoading) {
            return <Loader />
        } else {
            return <ListBike displayRightPage={this.props.displayRightPage} listBikes={this.props.bikeListFiltered} />
        }
    }
    
    render() {
        return (
            <div className="BikesPage">
                {this.displayBikePage()}
            </div>
        );
    }
}

export default BikesPage;